import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'btntools',
    templateUrl: 'btntools.component.html',
    styleUrls: ['btntools.component.scss'],
})
export class BtnToolsComponent {
    @Input() public hideButton: boolean = false;
    @Input() public btnToolList;
    @Output() public clickButton = new EventEmitter<any>();

    public onClickButton(BtnToolList) {
        this.clickButton.emit(BtnToolList);
    }
}
